export class Attendee {
    public first_name: string = '';
    public last_name: string = '';
    public t_shirt: string = '';
    public gender: string = '';
    public age: number = null;
    public medical: string  = '';
    public address: string  = '';
    public address_2: string  = '';
    public city: string  = '';
    public state: string = '';
    public zip_code: string = '';
    public email: string = '';
    public personal_phone_number: string = '';
    public num_attended: string = '';
    public food_allergies: string = '';
    public hear_about_cvcf: string = '';
    public comments_concerns: string = '';
    public emergency_contact_first_name: string = '';
    public emergency_contact_last_name: string = '';
    public emergency_email: string = '';
    public emergency_contact_phone_number: string = '';
    public emergency_contact_relationship: string = '';
    public your_church: string = '';
    public your_church_point_of_contact_name: string = '';
    public your_church_point_of_contact_number: string = '';
    public days_attending: string = '';
    public cost: number = null;
    public discount: string = '';
    public chargeId: string = '';
    public receiptUrl: string = '';
    public paid_status: string = '';
    public checked_in: boolean = false;
    public time_registered: string = '';
    public is_leader: boolean = false;
    public servant_title: string = '';
    public add_shirt: boolean = false;

    constructor() {

    }
}
